module.exports = "/images/feature-build-case-icon.svg?6b148872b7ca2387103728e639097b6e";